import { css } from '@emotion/react';

export const fare_rule_uta_list = css`
  margin-top: 12px;
`;
